import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Router from './router/Router';
import store from './redux';
import { ToastContainer } from 'react-toastify';
const App = () => {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <Router />
        <ToastContainer
          position="top-left"
          autoClose={1000}
          hideProgressBar={true}
          closeOnClick={true}
          pauseOnHover={true}
          draggable={true}
          limit={4}
          newestOnTop
        />
      </Provider>
    </BrowserRouter>
  );
};

export default App;
